import type { CSSProperties } from 'react';

/**
 * 명함과 조직도 트리가 함께 쓰는 두 가지 글자 모양. 컴포넌트 파일에 두면 그 파일이 컴포넌트만
 * 내보내지 않게 되어 개발 중 화면 갱신(fast refresh)이 통째로 끊긴다 — 그래서 따로 둔다.
 */
export const mutedText: CSSProperties = { fontSize: '12px', color: 'var(--text-muted)' };

/** 팀장 배지. 트리의 이름 옆과 명함의 소속 줄에 같은 모양으로 선다. */
export const leadBadge: CSSProperties = {
  fontSize: '10px',
  fontWeight: 600,
  padding: '1px 5px',
  borderRadius: '8px',
  background: '#fef3c7',
  color: '#b45309',
  flexShrink: 0,
};
